import { useState, useEffect, useCallback } from 'react'
import algoliaClient from './client'

const useGetObject = (id) => {
  const [data, setData] = useState({})
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const runQuery = useCallback(async () => {
    try {
      setLoading(true)
      const response = await algoliaClient.getObject(id)
      setData(response)
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [id])

  useEffect(() => {
    runQuery()
  }, [runQuery])

  return [data, loading, error]
}

export default useGetObject
